import { Stack } from '@mui/material'
import { roundingNumber } from 'components/shared/processes'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { TypographyPrimary12 } from 'ui/typography/TypographyPrimary12'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

export const FoodRemainedWidget: React.FC = () => {
	const { statistics } = useWidgetStatistics()
	const cleaning = statistics?.cleaning

	return (
		<Stack direction='column' gap='8px'>
			<TypographySecondary>Остаток</TypographySecondary>
			{!cleaning ? (
				<TypographySecondary14>Нет данных</TypographySecondary14>
			) : (
				<Stack direction='row' gap='4px' alignItems='center'>
					<TypographyPrimary16Bold>
						{roundingNumber(cleaning.total, 0).toLocaleString()}
					</TypographyPrimary16Bold>
					<TypographyPrimary12>кг</TypographyPrimary12>
				</Stack>
			)}
		</Stack>
	)
}
